import { Routes } from './routes';

/**
 * Sidebar-Bereiche der Rolle `unteradmin` (Entscheid Alex 16.10.2026 20:42):
 * Unteradmin = SA minus ausgeschaltete Bereiche. Schluessel identisch zu
 * `App\Enums\AdminBereich` im Backend; dort sitzt die verbindliche Sperre
 * (RestrictUnteradminRole). Hier wird nur Sidebar und FE-Route gefiltert.
 */
export type AdminBereich =
  | 'dashboard'
  | 'cockpit'
  | 'benutzer'
  | 'pipeline'
  | 'meetings'
  | 'kalender'
  | 'meeting-pools'
  | 'aufgaben'
  | 'mandanten'
  | 'aktivitaetslog'
  | 'segmente'
  | 'mail-templates'
  | 'antragserstellung'
  | 'neuigkeiten'
  | 'prozesse';

/** Detailseiten (Fall, Kunde, Termin) oeffnet man von jeder Datenseite aus. */
const DATEN: AdminBereich[] = ['mandanten', 'pipeline', 'meetings', 'aufgaben', 'kalender'];

/** Sidebar-Eintrag (Route-Pfad) → Bereich. */
export const BEREICH_JE_SIDEBAR_PFAD: Record<string, AdminBereich> = {
  [Routes.Dashboard]: 'dashboard',
  [Routes.Cockpit]: 'cockpit',
  [Routes.UsersTeams]: 'benutzer',
  [Routes.Deals]: 'pipeline',
  [Routes.Meetings]: 'meetings',
  [Routes.Calendar]: 'kalender',
  [Routes.MeetingPools]: 'meeting-pools',
  [Routes.Todos]: 'aufgaben',
  [Routes.Customers]: 'mandanten',
  [Routes.ActivityLog]: 'aktivitaetslog',
  [Routes.Segments]: 'segmente',
  [Routes.MailTemplates]: 'mail-templates',
  [Routes.ApplicationAdmin]: 'antragserstellung',
  [Routes.Neuigkeiten]: 'neuigkeiten',
  [Routes.Prozesse]: 'prozesse',
};

/** Erstes Pfadsegment unter /home → Bereiche (eines genuegt). */
const BEREICHE_JE_SEGMENT: Record<string, AdminBereich[]> = {
  [Routes.Dashboard]: ['dashboard'],
  [Routes.Sprechstunden]: ['dashboard'],
  [Routes.Organigramm]: ['dashboard'],
  [Routes.Lernplattform]: ['dashboard'],
  [Routes.KiTrainer]: ['dashboard'],
  [Routes.Cockpit]: ['cockpit'],
  [Routes.UsersTeams]: ['benutzer'],
  [Routes.Admin]: ['benutzer'],
  [Routes.Teams]: ['benutzer'],
  [Routes.Deals]: ['pipeline'],
  cases: DATEN,
  [Routes.Meetings]: ['meetings'],
  [Routes.Calendar]: ['kalender'],
  [Routes.MeetingPools]: ['meeting-pools'],
  [Routes.Todos]: ['aufgaben'],
  [Routes.Customers]: ['mandanten'],
  [Routes.ActivityLog]: ['aktivitaetslog'],
  [Routes.Segments]: ['segmente'],
  [Routes.MailTemplates]: ['mail-templates'],
  [Routes.ApplicationAdmin]: ['antragserstellung'],
  [Routes.ApplicationTypes]: ['antragserstellung'],
  [Routes.ApplicationProviders]: ['antragserstellung'],
  [Routes.ApplicationVpFields]: ['antragserstellung'],
  [Routes.ApplicationTemplates]: ['antragserstellung'],
  [Routes.Neuigkeiten]: ['neuigkeiten'],
  [Routes.Prozesse]: ['prozesse'],
};

/**
 * Bereiche, zu denen ein /home-Pfad gehoert. `null` = kein Bereich
 * (Telefonie-Wizard, Benachrichtigungen, Profil …) → immer offen.
 * Detailseiten (`meetings/12`, `customers/7`) zaehlen zu allen Datenbereichen.
 */
export const bereicheFuerPfad = (pathname: string): AdminBereich[] | null => {
  const teile = pathname.split('/').filter(Boolean);
  if (teile[0] !== Routes.Home || teile.length < 2) return null;

  const segment = teile[1];
  const bereiche = BEREICHE_JE_SEGMENT[segment];
  if (!bereiche) return null;

  const istDetail = teile.length > 2 && (segment === Routes.Meetings || segment === Routes.Customers);
  return istDetail ? DATEN : bereiche;
};
